import $ from 'jquery';

/**
 * @fileOverview View handles updating the visual elements on the page
 */
export default class Helpers {
    /**
     * Receive a path to a JSON file, get the JSON, parse and return the object.
     *
     * @method fromJSON
     * @param {string} path
     * @returns {object} with promise
     */
    fromJSON(path) {
        return new Promise((resolve, reject) => {
            $.post(path)
                .then(
                    response => {
                        resolve(response);
                    },
                    err => {
                        reject(new Error('getJSON Response Error: ', err));
                    });
        });
    }
}
